import { Font } from '@utmb/design-system/text/font';
import { useTranslation } from 'next-i18next';
import { ReactElement } from 'react';
import styles from './block-latest.module.scss';
import { BlockDashboardWrapper } from './BlockDashboardWrapper';
import { Slides, SlidesItem } from '@utmb/design-system/slides/Slides';
import { Link } from '@utmb/design-system/link/link';
import { Image } from '@utmb/design-system/image/Image';
import { Icon } from '@utmb/design-system/icons/Icon';
import { IconsEnum } from '@utmb/types/icons';
import { useDashboard } from '@utmb/contexts/DashboardContext';
import AdItemView from '@utmb/types/view/AdItemView';

export const BlockLatest = (): ReactElement => {
    const { t } = useTranslation('myutmb');
    const { dashboardMember } = useDashboard();

    const isInternalLink = (link: string) => {
        const utmbWorldRegExp = new RegExp('/utmb.world/g');
        return link.match(utmbWorldRegExp);
    };

    return dashboardMember?.dashboardAds ? (
        <BlockDashboardWrapper
            label={
                <>
                    <Font.FuturaMedium as="span">{t('myUtmb.myDashboard.latest1')}</Font.FuturaMedium>
                    &nbsp;
                    <Font.FuturaBold as="span">{t('myUtmb.myDashboard.latest2')}</Font.FuturaBold>
                </>
            }
        >
            <div className={styles.container}>
                <Slides
                    carouselOptions={{
                        containScroll: 'trimSnaps',
                        align: 'center',
                        draggable: true,
                    }}
                    controlsComponent={
                        <div className={styles.nav}>
                            <Icon variant={IconsEnum.CHEVRON_LEFT} />
                        </div>
                    }
                    prevXY={{ top: '50%', transform: 'translateY(-50%)', left: '-18px' }}
                    nextXY={{ top: '50%', transform: 'translateY(-50%) rotate(180deg)', right: '-18px' }}
                    dotsClassName={styles.dots}
                    className={styles.viewport}
                    pagination={true}
                >
                    {() => (
                        <>
                            {dashboardMember.dashboardAds.map((ad, index: number) => (
                                <SlidesItem key={index} className={styles.item}>
                                    {ad.link ? (
                                        isInternalLink(ad.link) ? (
                                            <Link href={ad.link}>
                                                <a target="_self">
                                                    <DashboardAd {...ad} />
                                                </a>
                                            </Link>
                                        ) : (
                                            <a href={ad.link} target="_blank" rel="noreferrer">
                                                <DashboardAd {...ad} />
                                            </a>
                                        )
                                    ) : (
                                        <DashboardAd {...ad} />
                                    )}
                                </SlidesItem>
                            ))}
                        </>
                    )}
                </Slides>
            </div>
        </BlockDashboardWrapper>
    ) : (
        <></>
    );
};

export const DashboardAd = ({ picture, logo, color }: AdItemView): ReactElement => {
    return (
        <>
            <Image objectFit="cover" layout="fill" image={picture} className={styles.bg} />
            {logo && (
                <div className={styles.logo_bg}>
                    <div>
                        <Icon variant={IconsEnum.LOGO_AD_BG} color={color} />
                    </div>
                    <div className={styles.logo}>
                        <div>
                            <Image objectFit="contain" layout="fill" maxWidth={240} image={logo} />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
